export default "__VITE_ASSET__DgE6WDFY__"